module.exports = __webpack_public_path__ + "img/Feature-2.cd55615.svg";